<template>
  <div class="p-2 pt-7 container-fluid mt-8 mb-12">
    <div class="row form-row">
      <div class="col-sm-12">
        <div class="card">
          <div class="p-2 card-body">
            <!-- Loading state -->
            <div v-if="loading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Cargando...</span>
              </div>
              <p class="mt-3">Verificando estado del pago...</p>
            </div>

            <!-- Success state -->
            <div v-if="!loading && paymentSuccess" class="text-center py-4">
              <i class="fas fa-check-circle fa-5x text-success mb-3"></i>
              <h4 class="mb-3">¡Pago confirmado!</h4>
              <p class="mb-4">Tu pago ha sido procesado exitosamente.</p>
      
              <button @click="goToCourse" class="btn btn-primary btn-lg">
                <i class="fas fa-book me-2"></i> Ir al curso
              </button>

            </div>

            <!-- Error state -->
            <div v-if="!loading && paymentError" class="text-center py-4">
              <i class="fas fa-times-circle fa-5x text-danger mb-3"></i>
              <h4 class="mb-3">Error en el pago</h4>
              <p class="text-muted mb-4">{{ errorMessage }}</p>
              <div class="d-flex justify-content-center gap-3">
                <button @click="goToCourse" class="btn btn-dark btn-lg">
                  <i class="fas fa-redo me-2"></i> Volver al curso
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { TilopayClient } from '@/services/TiloPayClient';

const tilopayClient = new TilopayClient();
const route = useRoute();
const router = useRouter();

const loading = ref(true);
const paymentSuccess = ref(false);
const paymentError = ref(false);
const errorMessage = ref('');
const cursoId = ref(null);

// Prepare payment data according to ConfirmPaymentDto
const preparePaymentData = () => {
  const paymentData = {
    code: route.query.code,
    order: route.query.order,
    auth: route.query.auth,
    description: route.query.description,
    'tilopay-transaction': route.query['tilopay-transaction'],
    returnData: route.query.returnData
  };

  return paymentData;
};

const checkPaymentStatus = async () => {
  try {
    const paymentData = preparePaymentData();

    // Validate required fields
    if (!paymentData.code || !paymentData.order || !paymentData['tilopay-transaction']) {
      throw new Error('Missing essential payment data');
    }

    // Prepare the exact payload your backend expects
    const confirmationPayload = {
      code: paymentData.code,
      order: paymentData.order,
      auth: paymentData.auth,
      description: paymentData.description,
      'tilopay-transaction': paymentData['tilopay-transaction'],
      returnData: paymentData.returnData
    };

    // Verify payment with Tilopay
    const verification = await tilopayClient.confirmPayment(confirmationPayload);
    console.log('Payment verification response:', verification);

    cursoId.value = verification.curso_id; // Store the curso_id from response
    if (verification.status != 'failed') {
      paymentSuccess.value = true;
    } else {
      throw new Error(verification.message || 'Payment not verified');
    }
  } catch (error) {
    paymentError.value = true;
    errorMessage.value = error.response?.data?.message || error.message || 'Error verifying payment';
    console.error('Payment verification error:', {
      error: error.response?.data || error.message,
      stack: error.stack
    });
  } finally {
    loading.value = false;
  }
};

const goToCourse = () => {
  router.push(`/cursos/${cursoId.value}`);

}

onMounted(() => {
  checkPaymentStatus();
});
</script>

<style scoped>
.payment-details {
  max-width: 400px;
  margin: 0 auto;
}
.card {
  max-width: 600px;
  margin: 0 auto;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
.btn-lg {
  padding: 0.75rem 1.5rem;
  font-size: 1.1rem;
}
.text-muted {
  color: #6c757d !important;
}
</style>